import { UNIT } from '~/environment-variables/unit.const'
import type { Column } from '~/ui/Table/types'

const transactionsColumns: Array<Column> = [
  {
    name: 'TXN HASH',
    field: 'transactionHash',
  },
  {
    name: 'AGE',
    field: 'age',
    isToggleColumn: true,
    tooltip: 'click to toggle timestamp'
  },
  {
    name: 'DATETIME',
    field: 'unixTimeStamp',
    isToggleColumn: true,
    tooltip: 'click to toggle age'
  },
  {
    name: 'BLOCK',
    field: 'blockNumber',
  },
  {
    name: 'METHOD',
    field: 'method',
  },
  {
    name: 'FROM',
    field: 'from',
  },
  {
    name: '',
    field: 'arrow-right',
  },
  {
    name: 'TO',
    field: 'to',
  },
  {
    name: 'VALUE',
    field: 'value',
    unit: UNIT,
    isHoverable: true,
  },
  {
    name: 'TXN FEE',
    field: 'transactionFee',
    unit: UNIT,
    isHoverable: true,
  },
]

export { transactionsColumns }